<template>
  <LoadingWrapper :state="status">
    <SideBarLayoutContent>
      <template #top-bar>
        <div class="flex flex-row items-center gap-2">
          <BackButton
            backup-route-name="objectives"
            icon="arrow_back"
            close
            class="mr-2 -ml-2"
          />
          <h1 class="text-headline-medium grow">
            {{ $t('coaching.objectives.archived.title') }}
          </h1>
        </div>
      </template>

      <ul v-if="data.objectives.length > 0" class="mx-auto flex w-full max-w-3xl flex-col gap-2">
        <li v-for="objective in data.objectives" :key="objective.id">
          <ObjectiveItem
            :objective="objective"
            :feedback-topics="feedbackTopics"
            :feedback-topic="
              feedbackTopics.find((feedbackTopic) => feedbackTopic.id === objective.feedbackTopicId)
            "
          />
        </li>
      </ul>

      <EmptyPage
        v-else
        :title="$t('coaching.objectives.archived.empty.title')"
        :description="$t('coaching.objectives.archived.empty.description')"
        icon="archive"
      />
    </SideBarLayoutContent>
  </LoadingWrapper>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import EmptyPage from '@/core/components/empty-states/EmptyPage.vue'
  import ObjectiveItem from '@/core/components/objective/ObjectiveItem.vue'
  import BackButton from '@/core/components/BackButton.vue'
  import { useCompleteFeedbackTopics } from '@/core/composables/use-complete-feedback-topics'
  import { useArchivedObjectives } from '@/core/composables/use-archived-objectives'
  import { useUserStore } from '@/stores/user.store'

  const { user } = useUserStore()
  const { data, status } = useArchivedObjectives(user.id)
  const { data: topicsData } = useCompleteFeedbackTopics()

  const feedbackTopics = computed(() => topicsData.value?.feedbackTopics ?? [])
</script>
